import { ProfileEntity } from '../ProfileEntity';
import { createEntityNodeView } from './createEntityNodeView';

export const ProfileNodeView = createEntityNodeView('profile', ProfileEntity, {
  extraAttrs: ['dataId'],
});
